export const ASPIRANT_TAGLINE = 'Be brave. Be free. Belong.';
export const ASPIRANT_DESCRIPTION = `Succeed without following the crowd.
Stumble without falling down. 
Be yourself without being alone.`;
export const ASPIRANT_CTA = 'DISCOVER HOW';
export const ASPIRANT_NAV_BAR_BUTTON_TEXT = 'Take the Quiz';
